import { render, staticRenderFns } from "./student-card-3.vue?vue&type=template&id=b8f93e14&scoped=true"
import script from "./student-card-3.vue?vue&type=script&lang=js"
export * from "./student-card-3.vue?vue&type=script&lang=js"
import style0 from "./student-card-3.vue?vue&type=style&index=0&id=b8f93e14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f93e14",
  null
  
)

export default component.exports